// Module
var code = "<i class=\"fa fa-fw fa-share-alt fa-rotate-270\" ng-style=\"{'visibility': vm.group.isMatrixUpToDate ? 'hidden' : 'visible'}\" style=\"cursor:pointer\" title=\"{{(vm.title||'Occurrence matrix needs to be updated')|translate}}\" ui-sref=\"group.script({groupGuid:vm.group.guid})\"> </i>";
// Exports
module.exports = code;